import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

/**
 * Container component for (form/page) action buttons - limited to the scope of cancellations
 */
const ActionButtonWrapper = styled(Box)(({ theme }) => ({
	gap: 2,
	display: 'flex',
	justifyContent: 'space-between',
	flexDirection: 'column-reverse',
	alignItems: 'center',
	width: '100%',
	'button, a': {
		width: '100%',
		'&:last-of-type': {
			marginBottom: '1em',
		},
	},
	[theme.breakpoints.up('sm')]: {
		flexDirection: 'row',
		alignItems: 'auto',
		'button, a': {
			width: 'auto',
			'&:last-of-type': {
				marginBottom: '0',
			},
		},
	},
}));
export default ActionButtonWrapper;
